import * as types from '../mutations-types'
import {createActionHelpers} from 'vuex-loading'
import {
  getVehiclesInAMission,
  modifyWhereMission,
  modifyDatesMission,
  modifyVehiclesMission,
  deleteMission,
  terminateMission,
  fetchMissionsServices,
  fetchMissionsTemplates,
  createMission,
  createBaseMission
} from '../../utils/api'
import Vue from 'vue'

const {startLoading} = createActionHelpers({
  moduleName: 'loading'
})
// STATE
const state = {
  showMessageReloadRequest: false,
  missionsServicesRaw: [],
  requestMissionsServices: false,
  missionsServices: [],
  missionsTemplates: [],
  missionsServicesRequest: {},
  showAutoReloadAlert: false,
  missionsInModification: [],
  vehiclesInAMission: []
}
// GETTERS
const getters = {
  showMessageReloadRequest: state => state.showMessageReloadRequest,
  missionsServicesRaw: state => state.missionsServicesRaw,
  requestMissionsServices: state => state.requestMissionsServices,
  missionsServices: state => state.missionsServices,
  missionsTemplates: state => state.missionsTemplates,
  missionsServicesRequest: state => state.missionsServicesRequest,
  showAutoReloadAlert: state => state.showAutoReloadAlert,
  missionsInModification: state => state.missionsInModification,
  vehiclesInAMission: state => state.vehiclesInAMission
}
// ACTIONS
const actions = {
  clearVehiclesInAMission({commit}) {
    commit(types.SET_VEHICLES_IN_A_MISSION, [])
  },
  async getVehiclesInAMission({dispatch, commit}, id) {
    // console.log('getVehiclesInAMission', id)
    try {
      const response = await startLoading(dispatch, 'gettingVehiclesInAMission', () => {
        return getVehiclesInAMission(id)
      })
      if (response) {
        // console.log('getVehiclesInAMission', response)
        commit(types.SET_VEHICLES_IN_A_MISSION, response.data)
      }
    } catch (error) {
      console.error('ERROR GVIAM: ', error)
    }
  },
  actionInMissionInProgress({commit}, data) {
    // console.log('actionInMissionInProgress: ', data)
    commit(types.SET_ACTIONS_IN_MISSION_PROGRESS, data)
    commit(types.SET_MISSIONS_IN_MODIFICATION, data)
  },
  setShowMessageReloadRequest({commit}, value) {
    commit(types.SET_SHOW_MESSAGE_RELOAD_REQUEST, value)
  },
  modifiedWhereMissionPusher({state, getters, commit, dispatch}, data) {
    if (state.missionsServices.length === 0) return
    const currentUser = getters['auth/getProfile'].name
    if (currentUser === data.modifiedUser) {
      dispatch('setShowAutoReloadAlert', true)
      dispatch('fetchMissionsServices', getters.missionsServicesRequest)
    } else {
      dispatch('setShowMessageReloadRequest', true)
      commit(types.UPDATE_MISSION_SERVICES_MODIFY_WHERE, data)
    }
    dispatch('triggerActionUnblock', data)
  },
  modifyWhereMission({dispatch}, payload) {
    return new Promise(async(resolve) => {
      try {
        const response = await startLoading(dispatch, 'modifyingMission', () => {
          return modifyWhereMission(payload)
        })
        // console.log('MODIFY WHERE MISSION', response)
        if (response.data.success) {
          resolve(response)
        }
      } catch (error) {
        console.error('ERROR MWM:')
        if (error.response.status === 422) {
          alert('ERROR!\n\nNo se pudo modificar la misión debido a que los datos ingresados no son validos.\n\n Por favor revise los datos de las zonas seleccionadas e intentelo de nuevo.')
        } else if (error.response.status === 409) {
          alert(`ERROR!\n\n${error.response.data.message}`)
        } else {
          alert('ERROR!\n\nNo se realizó la modificación de la misión debido a que las áreas recibidas son iguales a las que ya estan asignadas a la misión.')
        }
        error.response.data.success = false
        resolve(error.response)
      }
    })
  },
  modifiedWhenMissionPusher({state, getters, commit, dispatch}, data) {
    if (state.missionsServices.length === 0) return
    const currentUser = getters['auth/getProfile'].name
    if (currentUser === data.modifiedUser) {
      dispatch('setShowAutoReloadAlert', true)
      dispatch('fetchMissionsServices', getters.missionsServicesRequest)
    } else {
      dispatch('setShowMessageReloadRequest', true)
      commit(types.UPDATE_MISSION_SERVICES_MODIFY_WHEN, data)
    }
    dispatch('triggerActionUnblock', data)
  },
  modifyDatesMission({dispatch}, payload) {
    return new Promise(async(resolve) => {
      try {
        const response = await startLoading(dispatch, 'modifyingMission', () => {
          return modifyDatesMission(payload)
        })
        // console.log('MODIFY DATE MISSION', response)
        if (response.data.success) {
          resolve(response)
        }
      } catch (error) {
        console.error('ERROR MDM')
        if (error.response.status === 422) {
          alert('ERROR!\n\nNo se pudo modificar la misión debido a que los datos ingresados no son validos.\n\n Por favor revise los datos de las fechas y horas ingresadas e intentelo de nuevo.')
        } else if (error.response.status === 409) {
          alert(`ERROR!\n\n${error.response.data.message}`)
        } else {
          alert('ERROR!\n\nNo se pudo modificar la misión debido a que se presentó un error inesperado.\n\n Por favor intentelo nuevamente. Si éste error persiste contacte al administrador de la plataforma.')
        }
        error.response.data.success = false
        resolve(error.response)
      }
    })
  },
  modifiedWhoMissionPusher({state, getters, commit, dispatch}, data) {
    if (state.missionsServices.length === 0) return
    const currentUser = getters['auth/getProfile'].name
    if (currentUser === data.modifiedUser) {
      dispatch('setShowAutoReloadAlert', true)
      dispatch('fetchMissionsServices', getters.missionsServicesRequest)
    } else {
      dispatch('setShowMessageReloadRequest', true)
      commit(types.UPDATE_MISSION_SERVICES_MODIFY_WHO, data)
    }
    dispatch('triggerActionUnblock', data)
  },
  modifyVehiclesMission({dispatch}, payload) {
    return new Promise(async(resolve) => {
      try {
        const response = await startLoading(dispatch, 'modifyingMission', () => {
          return modifyVehiclesMission(payload)
        })
        // console.log('MODIFY VEHICLE MISSION', response)
        if (response.data.success) {
          resolve(response)
        }
      } catch (error) {
        console.error('ERROR MVM:')
        if (error.response.status === 422) {
          alert('ERROR!\n\nNo se pudo modificar la misión debido a que los datos ingresados no son validos.\n\n Por favor revise los datos de vehículos ingresados e intentelo de nuevo.')
        } else if (error.response.status === 409) {
          alert(`ERROR!\n\n${error.response.data.message}`)
        } else {
          alert('ERROR!\n\nNo se pudo modificar la misión debido a que se presentó un error inesperado.\n\n Por favor intentelo nuevamente. Si éste error persiste contacte al administrador de la plataforma.')
        }
        error.response.data.success = false
        resolve(error.response)
      }
    })
  },
  deleteMissionPusher({state, commit, dispatch}, data) {
    if (state.missionsServices.length === 0) return
    commit(types.UPDATE_MISSION_SERVICES_DELETE, data)
    dispatch('triggerActionUnblock', data)
  },
  terminateMissionPusher({state, commit, getters, dispatch}, data) {
    if (state.missionsServices.length === 0) return
    const currentUser = getters['auth/getProfile'].name
    if (currentUser === data.terminatedUser) {
      dispatch('setShowAutoReloadAlert', true)
      dispatch('fetchMissionsServices', getters.missionsServicesRequest)
    } else {
      dispatch('setShowMessageReloadRequest', true)
      commit(types.UPDATE_MISSION_SERVICES_TERMINATE, data)
    }
    dispatch('triggerActionUnblock', data)
  },
  deleteMission({dispatch}, payload) {
    return new Promise(async(resolve) => {
      try {
        const response = await startLoading(dispatch, 'deleteMission', () => {
          return deleteMission(payload)
        })
        // console.log('DELETE MISSION', response)
        if (response.data.success) {
          resolve(response)
        }
      } catch (error) {
        console.error('ERROR DM:')
        if (error.response.status === 422) {
          alert('ERROR!\n\nNo se pudo eliminar la misión debido a que los datos ingresados no son validos.\n\n Por favor revise la información ingresada e intentelo de nuevo.')
        } else if (error.response.status === 409) {
          alert(`ERROR!\n\n${error.response.data.message}`)
        } else {
          alert('ERROR!\n\nNo se pudo eliminar la misión debido a que se presentó un error inesperado.\n\n Por favor intentelo nuevamente. Si éste error persiste contacte al administrador de la plataforma.')
        }
        error.response.data.success = false
        resolve(error.response)
      }
    })
  },
  terminateMission({dispatch}, payload) {
    return new Promise(async(resolve) => {
      try {
        const response = await startLoading(dispatch, 'terminateMission', () => {
          return terminateMission(payload)
        })
        // console.log('TERMINATE MISSION', response)
        if (response.data.success) {
          resolve(response)
        }
      } catch (error) {
        console.error('ERROR TM:')
        if (error.response.status === 422) {
          alert('ERROR!\n\nNo se pudo terminar anticipadamente la misión debido a que los datos ingresados no son validos.\n\n Por favor revise la información ingresada e intentelo de nuevo.')
        } else if (error.response.status === 409) {
          alert(`ERROR!\n\n${error.response.data.message}`)
        } else {
          alert('ERROR!\n\nNo se pudo eliminar la misión debido a que se presentó un error inesperado.\n\n Por favor intentelo nuevamente. Si éste error persiste contacte al administrador de la plataforma.')
        }
        error.response.data.success = false
        resolve(error.response)
      }
    })
  },
  initMissionsServices({commit}) {
    commit(types.FETCH_MISSIONS_SERVICES, [])
    commit(types.REQUEST_MISSIONS_SERVICES, false)
  },
  async fetchMissionsServices({commit, dispatch, getters}, payload) {
    commit(types.SET_MISSIONS_SERVICES_DATE_TIME, payload)
    try {
      // console.log('PAYLOAD', payload)
      let vehicleIdRequest = null
      if (payload.hasOwnProperty('vehicleId')) vehicleIdRequest = payload.vehicleId
      // console.log('VEHICLE ID REQUEST', vehicleIdRequest)

      commit(types.FETCH_MISSIONS_SERVICES, [])
      commit(types.REQUEST_MISSIONS_SERVICES, false)
      const response = await startLoading(dispatch, 'fetchMissionsServices', () => {
        return fetchMissionsServices(payload)
      })
      if (response) {
        // console.log('fetchMissionsServices: ', response)
        const data = response.data
        commit(types.FETCH_MISSIONS_SERVICES_RAW, data)
        const dataForTable = []
        data.forEach(mission => {
          mission.vehicles.forEach(vehicle => {
            const obj = {
              missionID: mission.id,
              baseMissionId: mission.baseMissionId,
              vehicleId: vehicle.id,
              licensePlate: vehicle.licensePlate,
              code: vehicle.code,
              agencyId: vehicle.agencyId,
              name: mission.name,
              description: mission.description,
              startDateUnique: mission.dates.start,
              endDateUnique: mission.dates.end,
              startTimeUnique: mission.time.start,
              endTimeUnique: mission.time.end,
              startDate: vehicle.initialDate,
              endDate: vehicle.finalDate,
              actions: mission.actions,
              vehiclesInMission: mission.quantity,
              whereSelected: mission.where,
              inProgressRemote: false,
              userInProgressRemote: '',
              terminatedAt: mission.terminatedAt,
              analyzeParking: mission.analyzeParking
            }
            if (vehicleIdRequest !== null) {
              if (vehicleIdRequest === obj.vehicleId) dataForTable.push(obj)
            } else dataForTable.push(obj)
          })
        })
        commit(types.SET_SHOW_AUTO_RELOAD_ALERT, false)
        commit(types.FETCH_MISSIONS_SERVICES, dataForTable)
        commit(types.REQUEST_MISSIONS_SERVICES, true)

        // Verify if a mission or missions are in current modification
        getters.missionsInModification.forEach(element => {
          commit(types.SET_ACTIONS_IN_MISSION_PROGRESS, element)
        })
      }
    } catch (error) {
      console.error('ERROR FMS: ', error)
    }
  },
  async fetchMissionsTemplates({commit, dispatch}) {
    try {
      // console.log('FETCH MISSIONS TEMPLATES START!')
      const response = await startLoading(dispatch, 'fetchMissionsTemplates', () => {
        return fetchMissionsTemplates()
      })
      if (response) {
        // console.log('FETCH MISSIONS TEMPLATES: ', response.data)
        commit(types.FETCH_MISSIONS_TEMPLATES, response.data)
      }
    } catch (error) {
      console.error('ERROR FMT: ', error)
    }
  },
  createMission({commit}, payload) {
    return new Promise(async(resolve, reject) => {
      try {
        const response = await createMission(payload)
        if (response) {
          resolve(response)
        } else {
          reject(new Error('Error at Create Mission'))
        }
      } catch (e) {
        reject(e)
      }
    })
  },
  setShowAutoReloadAlert({commit}, value) {
    commit(types.SET_SHOW_AUTO_RELOAD_ALERT, value)
  },
  setMissionsInModification({commit}, payload) {
    commit(types.SET_MISSIONS_IN_MODIFICATION, payload)
  },
  triggerActionUnblock({getters}, payload) {
    // console.log('triggerActionUnblock', payload)
    const channel = getters.pusherRef.channels.channels['presence-action-in-mission-in-progress']
    // console.log('pusherRef', getters.pusherRef)
    channel.trigger(
      'client-action-in-mission-in-progress',
      {
        i: payload.id,
        a: payload.actions,
        v: false,
        u: ''
      }
    )
  },
  createBaseMission({dispatch}, payload) {
    return new Promise(async(resolve) => {
      try {
        const response = await startLoading(dispatch, 'creatingBaseMission', () => {
          return createBaseMission(payload)
        })
        console.log('RESPONSE createBaseMission', response)
        if (response.data.success) {
          resolve(response.data.success)
        }
      } catch (error) {
        console.error('ERROR CBM:', error)
        resolve(error.response)
      }
    })
  }
}
// MUTATIONS
const mutations = {
  [types.SET_SHOW_MESSAGE_RELOAD_REQUEST](state, value) {
    state.showMessageReloadRequest = value
  },
  [types.UPDATE_MISSION_SERVICES_MODIFY_WHERE](state, data) {
    for (let index = 0; index < state.missionsServices.length; index++) {
      const element = state.missionsServices[index]
      if (element.missionID === data.id) {
        Vue.set(state.missionsServices[index], 'actions', data.actions)
        Vue.set(state.missionsServices[index], 'whereSelected', data.where)
      }
    }

    const index = state.missionsServicesRaw.findIndex(item => item.id === data.id)
    if (index !== -1) {
      Vue.set(state.missionsServicesRaw[index], 'modifiedAt', data.modifiedAt)
      Vue.set(state.missionsServicesRaw[index], 'modifiedUser', data.modifiedUser)
      Vue.set(state.missionsServicesRaw[index], 'modifiedWhy', data.modifiedWhy)
      Vue.set(state.missionsServicesRaw[index], 'where', data.where)
    }
  },
  [types.UPDATE_MISSION_SERVICES_MODIFY_WHEN](state, data) {
    for (let index = 0; index < state.missionsServices.length; index++) {
      const element = state.missionsServices[index]
      if (element.missionID === data.id) {
        Vue.set(state.missionsServices[index], 'actions', data.actions)
        Vue.set(
          state.missionsServices[index],
          'startDate',
          `${data.dates.start} ${data.time.start}`
        )
        Vue.set(
          state.missionsServices[index],
          'endDate',
          `${data.dates.end} ${data.time.end}`
        )
      }
    }

    const index = state.missionsServicesRaw.findIndex(item => item.id === data.id)
    if (index !== -1) {
      Vue.set(state.missionsServicesRaw[index], 'modifiedAt', data.modifiedAt)
      Vue.set(state.missionsServicesRaw[index], 'modifiedUser', data.modifiedUser)
      Vue.set(state.missionsServicesRaw[index], 'modifiedWhy', data.modifiedWhy)
      Vue.set(state.missionsServicesRaw[index], 'time', data.time)
      Vue.set(state.missionsServicesRaw[index], 'dates', data.dates)
    }
  },
  [types.UPDATE_MISSION_SERVICES_MODIFY_WHO](state, data) {
    for (let index = 0; index < state.missionsServices.length; index++) {
      const element = state.missionsServices[index]
      if (element.missionID === data.id) {
        Vue.set(state.missionsServices[index], 'actions', data.actions)
      }
    }
  },
  [types.UPDATE_MISSION_SERVICES_DELETE](state, data) {
    let index = state.missionsServicesRaw.findIndex(item => item.id === data.id)
    if (index !== -1) {
      state.missionsServicesRaw.splice(index, 1)
    }
    const newMissionsServices = []
    for (index = 0; index < state.missionsServices.length; index++) {
      const element = state.missionsServices[index]
      if (element.missionID !== data.id) newMissionsServices.push(element)
    }
    state.missionsServices = newMissionsServices
  },
  [types.UPDATE_MISSION_SERVICES_TERMINATE](state, data) {
    // const newMissionsServices = []
    // const requestEndDate = state.missionsServicesRequest.end
    for (let index = 0; index < state.missionsServices.length; index++) {
      const element = state.missionsServices[index]
      if (element.missionID === data.id) {
        Vue.set(state.missionsServices[index], 'actions', data.actions)
        Vue.set(state.missionsServices[index], 'endDate', data.terminatedAt)

        // const match = this.$moment(data.terminatedAt).isBefore(requestEndDate)
        // if (match) newMissionsServices.push(element)
      }
      // newMissionsServices.push(element)
    }
    // state.missionsServices = newMissionsServices

    const index = state.missionsServicesRaw.findIndex(item => item.id === data.id)
    if (index !== -1) {
      Vue.set(state.missionsServicesRaw[index], 'terminatedAt', data.terminatedAt)
      Vue.set(state.missionsServicesRaw[index], 'terminatedUser', data.terminatedUser)
      Vue.set(state.missionsServicesRaw[index], 'terminatedWhy', data.terminatedWhy)
    }
  },
  [types.FETCH_MISSIONS_SERVICES_RAW](state, data) {
    state.missionsServicesRaw = data
  },
  [types.REQUEST_MISSIONS_SERVICES](state, value) {
    state.requestMissionsServices = value
  },
  [types.FETCH_MISSIONS_SERVICES](state, data) {
    state.missionsServices = data
  },
  [types.FETCH_MISSIONS_TEMPLATES](state, data) {
    state.missionsTemplates = data
  },
  [types.SET_MISSIONS_SERVICES_DATE_TIME](state, data) {
    state.missionsServicesRequest = data
  },
  [types.SET_SHOW_AUTO_RELOAD_ALERT](state, value) {
    state.showAutoReloadAlert = value
  },
  [types.SET_ACTIONS_IN_MISSION_PROGRESS](state, data) {
    // console.log('SET_ACTIONS_IN_MISSION_PROGRESS', data)
    for (let index = 0; index < state.missionsServices.length; index++) {
      const element = state.missionsServices[index]
      if (element.missionID === data.i) {
        Vue.set(state.missionsServices[index], 'actions', data.a)
        Vue.set(state.missionsServices[index], 'inProgressRemote', data.v)
        Vue.set(state.missionsServices[index], 'userInProgressRemote', data.u)
      }
    }
  },
  [types.SET_MISSIONS_IN_MODIFICATION](state, payload) {
    if (payload.v) {
      state.missionsInModification.push(payload)
    } else {
      const index = state.missionsInModification.findIndex(item => item.i === payload.i)
      if (index !== -1) {
        state.missionsInModification.splice(index, 1)
      }
    }
  },
  [types.SET_VEHICLES_IN_A_MISSION](state, payload) {
    state.vehiclesInAMission = payload
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/missions.js